import { sessionStorageDisabledConfirmationsKey } from "variables";

export const isDeleteModalDisabled = (type) =>
  sessionStorage
    .getItem(sessionStorageDisabledConfirmationsKey)
    ?.includes(type);
